import { EXTENSIONS } from 'probonio-shared-ui/registry';
import { ExtensionBuilder } from 'probonio-shared-ui/registry/extension-definition';
import { BenefitListItemExtensionInterface } from '../../../extension/interface/benefit-list-item.extension.interface';
import { BenefitMetadataExtensionInterface } from '../../../extension/interface/benefit-metadata.extension.interface';
import { DiscountCodeBenefitListItemExtension } from './discount-code-benefit-list-item.extension';
import { DiscountCodeBenefitMetadataExtension } from './discount_code-benefit-metadata.extension';

EXTENSIONS.registerExtension(
  new ExtensionBuilder('discount_code')
    .add(BenefitMetadataExtensionInterface, new DiscountCodeBenefitMetadataExtension())
    .add(BenefitListItemExtensionInterface, new DiscountCodeBenefitListItemExtension())
    .build(),
);
